import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

const UploadNotification = forwardRef((props, ref) => {

    const notificationRef = useRef<Notification>(null);

    useImperativeHandle(ref, () => {
        return {
            showNotification: (title: string, text: string) => showNotification(title, text)
        }
    })

    useEffect(() => {
        if ("Notification" in window) {
        if (Notification.permission === "default") {
            Notification.requestPermission();
        }
        }
    }, []);

    const showNotification = (title: string, text: string) => {
        if (Notification.permission === "granted") {
            const notification = new Notification(title, {
            body: text,
            icon: "/Georges_Icon_192.png",
        });

        /*setTimeout(() => {
            notification.close();
        }, 5000);*/
        } else {
            Notification.requestPermission();
        }
    };

    return (null);
});

export default UploadNotification;